import { render, staticRenderFns } from "./select-payment-method.vue?vue&type=template&id=6c05a845"
import script from "./select-payment-method.vue?vue&type=script&lang=js"
export * from "./select-payment-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports